export type GifProvider = 'klipy' | 'tenor';

export const PROVIDER_CONFIG: Record<GifProvider, { name: string; url: string }> = {
	klipy: { name: 'KLIPY', url: 'https://klipy.com' },
	tenor: { name: 'Tenor', url: 'https://tenor.com' },
};

export const detectProviderFromUrl = (url?: string): GifProvider | null => {
	if (!url) return null;
	if (url.includes('klipy.com')) return 'klipy';
	if (url.includes('tenor.com')) return 'tenor';
	return null;
};
